import SockJS from 'sockjs-client';
import {Client} from '@stomp/stompjs';
import { getToken } from '@/utils/token'
import serialPortManager from "@/utils/serial";
import router from '@/router'
import {Toast} from 'vant'

import {handleThirdOrder} from '@/api/home';


class WebSocketClient {

  constructor() {
    this.stompClient = null;
    this.isConnected = false;
    this.connectUrl = `https://gxcloudhw.onki.cn:8444/api/ws/connect`;
    //this.connectUrl = `http://192.168.1.111:8081/ws/connect`;

    // 重连相关属性
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 10;
    this.reconnectDelay = 3000;
    this.maxReconnectDelay = 30000;
    this.reconnectTimer = null;
    this.manualDisconnect = false;
    this.subscriptions = new Map();

    // 消息队列
    this.messageQueue = [];

    this.dataHandler = this.dataHandler.bind(this);
    this.handleReconnect = this.handleReconnect.bind(this);
    this.lastWebSocketCommandTime= null; // 记录最后收到指令的时间
    this.szfOrder = null;

  }

  /**
   * 建立连接
   */
  connect() {
    if (this.isConnected) return;

    console.log('正在连接 WebSocket...');

    // 创建 SockJS 实例
    const socket = new SockJS(this.connectUrl);

    // 创建 STOMP 客户端 - 调整心跳配置
    this.stompClient = new Client({
      webSocketFactory: () => socket,
      //debug: (str) => {console.log('[STOMP Debug]', str);},
      reconnectDelay: 0, // 禁用内置重连，使用自定义重连逻辑

      // 关键：调整心跳配置
      // 如果后端支持STOMP心跳，使用以下配置
      heartbeatIncoming: 10000,  // 期望每10秒收到服务端心跳
      heartbeatOutgoing: 10000,  // 每10秒向服务端发送心跳

      onConnect: (frame) => {
        console.log('WebSocket 连接成功：', frame);
        this.handleConnectSuccess(frame);
      },

      onStompError: (frame) => {
        console.error('STOMP 协议错误：', frame);
        this.handleConnectionError('STOMP 错误');
      },

      onWebSocketError: (error) => {
        console.error('WebSocket 连接错误：', error);
        this.handleConnectionError('WebSocket 错误');
      },

      onDisconnect: () => {
        console.log('WebSocket 已断开');
        this.handleDisconnect();
      },

      onWebSocketClose: (event) => {
        console.log('WebSocket 连接关闭，code:', event.code, 'reason:', event.reason);
        this.handleWebSocketClose(event);
      }
    });

    // 携带 Token 认证
    const token = getToken();
    this.stompClient.connectHeaders = {
      Authorization: token
    };

    // 启动连接
    this.stompClient.activate();

    // 设置网络监听
    this.setupNetworkListeners();
  }

  /**
   * 处理连接成功
   */
  handleConnectSuccess(frame) {
    this.isConnected = true;
    this.reconnectAttempts = 0;

    // 订阅主题
    this.subscribeWsTopics();

    // 触发重连成功回调（如果是重连）
    if (this.reconnectAttempts > 0) {
      console.log(`第 ${this.reconnectAttempts} 次重连成功`);
    }
  }

  /**
   * 处理连接错误
   */
  handleConnectionError(error) {
    console.error('连接错误：', error);
    this.isConnected = false;

    // 如果不是手动断开，尝试重连
    if (!this.manualDisconnect) {
      this.scheduleReconnect();
    }
  }

  /**
   * 处理 WebSocket 关闭
   */
  handleWebSocketClose(event) {
    console.log(`WebSocket 连接关闭：code=${event.code}, reason=${event.reason}`);
    this.isConnected = false;

    // 注意：移除了自定义心跳停止
    // this.stopHeartbeat();

    // 如果不是手动断开且不是正常关闭，尝试重连
    if (!this.manualDisconnect && event.code !== 1000) {
      this.scheduleReconnect();
    }
  }

  /**
   * 处理断开连接
   */
  handleDisconnect() {
    this.isConnected = false;
    // 注意：移除了自定义心跳停止
    // this.stopHeartbeat();

    // 如果不是手动断开，尝试重连
    if (!this.manualDisconnect) {
      this.scheduleReconnect();
    }
  }

  /**
   * 调度重连（指数退避算法）
   */
  scheduleReconnect() {
    // 检查是否超过最大重连次数
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.error(`已达到最大重连次数: ${this.maxReconnectAttempts}，停止重连`);
      return;
    }

    this.reconnectAttempts++;

    // 计算延迟时间（指数退避 + 随机抖动）
    const baseDelay = Math.min(
      this.reconnectDelay * Math.pow(1.5, this.reconnectAttempts - 1),
      this.maxReconnectDelay
    );
    const jitter = Math.random() * 2000; // 0-2秒随机抖动
    const delay = Math.floor(baseDelay + jitter);

    console.log(`第 ${this.reconnectAttempts} 次重连，${delay}ms 后尝试...`);

    // 清除之前的定时器
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
    }

    // 设置重连定时器
    this.reconnectTimer = setTimeout(() => {
      this.handleReconnect();
    }, delay);
  }

  /**
   * 执行重连
   */
  handleReconnect() {
    if (this.manualDisconnect) {
      console.log('手动断开，不进行重连');
      return;
    }

    console.log('执行重连...');

    // 先断开现有连接
    if (this.stompClient && this.stompClient.active) {
      this.stompClient.deactivate();
    }

    // 短暂延迟后重新连接
    setTimeout(() => {
      this.connect();
    }, 100);
  }

  /**
   * 订阅 WebSocket 主题
   */
  subscribeWsTopics() {
    // 订阅 SZF 专属广播路径
    const broadcastSub = this.subscribe('/topic/szf', (msg) => {
      console.log('收到 SZF 广播消息', msg);
      this.handleBroadcastMessage(msg);
    });

    if (broadcastSub) {
      this.subscriptions.set('broadcast', {
        destination: '/topic/szf',
        subscription: broadcastSub
      });
    }

    // 订阅 SZF 专属点对点路径
    const privateSub = this.subscribe('/user/queue/szf', (msg) => {
      console.log('收到SZF线上订单', msg.orderNo);
      this.handlePrivateMessage(msg);
    });

    if (privateSub) {
      this.subscriptions.set('private', {
        destination: '/user/queue/szf',
        subscription: privateSub
      });
    }
  }

  /**
   * 处理点对点消息
   */
  handlePrivateMessage(msg) {
    this.szfOrder = msg;

    serialPortManager.connect()
      .then(() => {
        serialPortManager.sendCommand(msg.send);
        serialPortManager.addDataListener(this.dataHandler);
      })
      .catch(err => {
        console.error('串口连接失败', err);
      });
  }

  /**
   * 添加数据监听 新
   */
  dataHandler(hexData) {
    serialPortManager.removeDataListener(this.dataHandler);
    serialPortManager.disconnect();
    this.lastWebSocketCommandTime = Date.now();
    this.szfOrder.receive = hexData.join('');
    handleThirdOrder(this.szfOrder);

    if ( this.szfOrder.source=== 'RETAIL_MP'){
      // 判断是否是POS机返回数据
      let music = new Audio();
      if (serialPortManager.isPayPacket(this.szfOrder.receive)) {
        music.src = require('@/assets/pay_success.mp3')
        music.play();
        // 避免重复导航到当前路由
        if (router.currentRoute.name !== 'success') {
          router.push({
            name: "success",
            params: {}
          }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
        }
      } else {
        Toast({
          message: '支付验证失败，请重试或联系工作人员',
          type: 'fail',
          duration: 3000
        })
        music.src = require('@/assets/pay_fail.mp3')
        music.play();

      }
    }
  }

  /**
   * 添加数据监听 暂停使用
   */
  /*dataHandler(hexData) {
    serialPortManager.removeDataListener(this.dataHandler);
    serialPortManager.disconnect();
    this.lastWebSocketCommandTime = Date.now();
    this.szfOrder.receive = hexData.join('');
    handleThirdOrder(this.szfOrder);
  }*/

  /**
   * 订阅消息
   */
  subscribe(destination, callback) {
    if (!this.isConnected || !this.stompClient) {
      console.warn(`无法订阅 ${destination}: 连接未就绪`);
      return null;
    }

    try {
      return this.stompClient.subscribe(destination, (message) => {
        try {
          const data = JSON.parse(message.body);
          callback(data);
        } catch (e) {
          callback(message.body);
        }
      });
    } catch (error) {
      console.error(`订阅失败 ${destination}:`, error);
      return null;
    }
  }

  /**
   * 发送消息
   */
  send(destination, data, options = {}) {
    if (!this.isConnected || !this.stompClient) {
      console.warn(`无法发送消息到 ${destination}: 连接未就绪`);

      if (options.queue !== false) {
        this.messageQueue.push({
          destination,
          body: JSON.stringify(data),
          timestamp: Date.now(),
          retryCount: 0,
          maxRetry: options.maxRetry || 3
        });
        return false;
      }

      return false;
    }

    try {
      this.stompClient.publish({
        destination,
        body: JSON.stringify(data)
      });
      return true;
    } catch (error) {
      console.error(`发送消息失败 ${destination}:`, error);

      if (options.retry !== false) {
        this.messageQueue.push({
          destination,
          body: JSON.stringify(data),
          timestamp: Date.now(),
          retryCount: 0,
          maxRetry: options.maxRetry || 3
        });
      }

      return false;
    }
  }

  /**
   * 断开连接
   */
  disconnect() {
    this.manualDisconnect = true;

    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }

    this.reconnectAttempts = 0;
    this.messageQueue = [];

    if (this.stompClient) {
      this.stompClient.deactivate();
    }

    this.isConnected = false;
    console.log('WebSocket 手动断开');
  }

  /**
   * 重新连接（手动触发）
   */
  reconnect() {
    this.manualDisconnect = false;
    this.reconnectAttempts = 0;

    console.log('手动触发重新连接');

    if (this.stompClient && this.stompClient.active) {
      this.stompClient.deactivate();
    }

    setTimeout(() => {
      this.connect();
    }, 100);
  }

  /**
   * 设置网络监听
   */
  setupNetworkListeners() {
    window.addEventListener('online', () => {
      console.log('网络恢复');
      if (!this.isConnected && !this.manualDisconnect) {
        this.reconnect();
      }
    });
  }
}

export default new WebSocketClient();
